import React, { useState } from 'react';
import { Check, RefreshCw, ShieldCheck, X } from 'lucide-react';
import { API_BASE } from '../config';

export default function BrowserLogin({ jobId, approval }) {
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [image, setImage] = useState(approval.artifacts?.[0]?.url || '');
  const qr = approval.kind === 'qr_login';
  const expired = approval.expires_at * 1000 < Date.now();
  const submit = async (mode, event) => {
    event?.preventDefault();
    setBusy(true);
    setError('');
    try {
      const cancel = mode === 'cancel';
      const endpoint = cancel ? 'browser-approvals' : 'browser-input';
      const response = await fetch(`${API_BASE}/v1/chat/jobs/${jobId}/${endpoint}/${approval.pending_id}`, {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cancel ? { approved: false } : mode === 'refresh' ? { refresh: true } : { values: qr ? {} : values }),
      });
      if (!response.ok) throw new Error('请求已过期、页面变化或连接中断。请核实页面状态后重新发起登录，不要重复发送密码。');
      if (mode === 'refresh') {
        const result = await response.json();
        setImage(result.artifacts?.[0]?.url || '');
      } else {
        setValues({});
        setDone(true);
      }
    } catch (err) { setError(err.message); setValues({}); }
    finally { setBusy(false); }
  };
  return <div className="browser-approval browser-login" role="dialog" aria-label={qr ? '扫码登录' : '安全登录输入'}>
    <div className="browser-approval-heading"><ShieldCheck size={16} /><strong>{qr ? '请在手机上扫码登录' : '需要你填写登录信息'}</strong></div>
    <div className="browser-approval-url">{approval.url}</div>
    {done || expired || approval.state !== 'pending' ? <span>此请求已处理或已过期。登录结果以网页核实为准。</span> : <>
      <p className="browser-login-hint">{qr ? '扫码并在手机上确认后，点击继续。' : '输入值只送到当前网页，不发送给模型，也不写入聊天记录。'}</p>
      {qr && image && <div className="browser-artifact"><a href={image} target="_blank" rel="noreferrer"><img src={image} alt="当前登录页面，请仅扫描你信任的网站二维码" /></a></div>}
      <form onSubmit={event => submit('submit', event)} autoComplete="off">
        {!qr && approval.fields?.map(field => <label className="browser-login-field" key={field.id}>
          <span>{field.label}</span><input type={field.kind === 'account' ? 'text' : 'password'}
            autoComplete="off" spellCheck={false} required maxLength={2000} disabled={busy}
            value={values[field.id] || ''} onChange={event => setValues(previous => ({ ...previous, [field.id]: event.target.value }))} />
        </label>)}
        <div className="browser-approval-actions">
          <button type="button" disabled={busy} onClick={() => submit('cancel')}><X size={14} />取消</button>
          {qr && <button type="button" disabled={busy} onClick={() => submit('refresh')}><RefreshCw size={14} />刷新截图</button>}
          <button type="submit" disabled={busy}><Check size={14} />{qr ? '已扫码，继续检查' : '安全填写到网页'}</button>
        </div>
      </form>
    </>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
